<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="3")
              div.text-center {{ $t('ui.full_time') }}
            th(colspan="3")
              div.text-center {{ $t('ui.half_time') }}
          tr
            th(style="width: 100px;")
              div {{ $t('ui.first_goal') }}
            th(style="width: 100px;")
              div {{ $t('ui.last_goal') }}
            th(style="width: 100px;")
              div {{ $t('ui.no_goal') }}
            th(style="width: 100px;")
              div {{ $t('ui.first_goal') }}
            th(style="width: 100px;")
              div {{ $t('ui.last_goal') }}
            th(style="width: 100px;")
              div {{ $t('ui.no_goal') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;")
              div(:class="{'up': item.ffgh_blink }") {{ item.ffgh }}
              div(:class="{'up': item.ffga_blink }") {{ item.ffga }}
            td(style="width: 100px;")
              div(:class="{'up': item.flgh_blink }") {{ item.flgh }}
              div(:class="{'up': item.flga_blink }") {{ item.flga }}
            td(style="vertical-align:middle;width: 100px;")
              div(:class="{'up': item.fng_blink }") {{ item.fng }}
            td(style="width: 100px;")
              div(:class="{'up': item.hfgh_blink }") {{ item.hfgh }}
              div(:class="{'up': item.hfga_blink }") {{ item.hfga }}
            td(style="width: 100px;")
              div(:class="{'up': item.hlgh_blink }") {{ item.hlgh }}
              div(:class="{'up': item.hlga_blink }") {{ item.hlga }}
            td(style="vertical-align:middle;width: 100px;")
              div(:class="{'up': item.hng_blink }") {{ item.hng }}
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>